import { Box } from '@mui/material';
import { GhostSide } from '~/engine/core/render/renderers/slices/adjacentSliceGhost';

/** A 16 px sample of the line an adjacent-slice ghost on `side` is drawn with, in `color` or the text colour. */
export default function GhostLineSample({
    side,
    color = 'currentColor',
}: {
    side: GhostSide;
    color?: string;
}) {
    return (
        <Box
            component="span"
            aria-hidden
            sx={{
                display: 'inline-block',
                width: 16,
                borderTop: `2px ${side} ${color}`,
            }}
        />
    );
}
